import { actionTypes } from './actions';
import initialState from './initialState';

export default function unexplainedPaymentsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_START:
      return state.set('loading', true).set('error', null);
    case actionTypes.REQUEST_SUCCESS:
      return state.set('loading', false).set('data', action.payload).set('error', null);
    case actionTypes.REQUEST_FAILURE:
      return state.set('loading', false).set('data', null).set('error', action.payload);
    case actionTypes.REQUEST_START_EXISTING:
      return state.set('loading', true).set('existing', null).set('error', null);
    case actionTypes.REQUEST_SUCCESS_EXISTING:
      return state.set('loading', false).set('existing', action.payload).set('error', null);
    case actionTypes.FETCH_ADM_FILTERS_START:
      return state.set('filtersLoading', true).set('filters', []).set('filtersError', false);
    case actionTypes.FETCH_ADM_FILTERS_SUCCESS:
      return state
        .set('filtersLoading', false)
        .set('filters', action.payload)
        .set('filtersError', false);
    case actionTypes.FETCH_ADM_FILTERS_FAILURE:
      return state.set('filtersLoading', false).set('filters', []).set('filtersError', true);
    default:
      return state;
  }
}
